import k from '../k'
import addRobot from '../parts/addRobot'
import addUI from '../parts/addUI'
import addPart from '../parts/addPart'
import { platformSpeed } from '../state/globals'
import addVoid from '../parts/addVoid'

export default () => {
  k.setGravity(1000)
  k.add([k.sprite('background'), k.fixed()])

  const { partDisplay } = addUI(4)

  const robot = addRobot(true, partDisplay)
  const tooltipE = robot.add([k.sprite('e'), k.anchor('bot'), k.pos(0, -12)])
  tooltipE.hidden = true

  addPart(partDisplay, 130, 0)

  addVoid(350)

  k.add([
    k.sprite('grass'),
    k.pos(-20, 20),
    k.body({ isStatic: true }),
    k.area()
  ])

  const platform = k.add([
    k.sprite('platform'),
    k.pos(220, 80),
    k.body({ isStatic: true }),
    k.area()
  ])

  let direction = platformSpeed
  platform.onUpdate(() => {
    if (platform.worldPos().y <= -10) direction = platformSpeed
    else if (platform.worldPos().y >= 90) direction = -platformSpeed

    platform.move(k.vec2(0, direction))
  })

  const platform2 = k.add([
    k.sprite('platform'),
    k.pos(320, -50),
    k.body({ isStatic: true }),
    k.area()
  ])

  let direction2 = -platformSpeed
  platform2.onUpdate(() => {
    if (platform2.worldPos().y <= -60) direction2 = platformSpeed
    else if (platform2.worldPos().y >= 40) direction2 = -platformSpeed

    platform2.move(k.vec2(0, direction2))
  })

  const platform3 = k.add([
    k.sprite('platform'),
    k.pos(420, 80),
    k.body({ isStatic: true }),
    k.area()
  ])

  let direction3 = platformSpeed
  platform3.onUpdate(() => {
    if (platform3.worldPos().y <= -10) direction3 = platformSpeed
    else if (platform3.worldPos().y >= 90) direction3 = -platformSpeed

    platform3.move(k.vec2(0, direction3))
  })

  const platform4 = k.add([
    k.sprite('platform'),
    k.pos(520, -50),
    k.body({ isStatic: true }),
    k.area()
  ])

  let direction4 = -platformSpeed
  platform4.onUpdate(() => {
    if (platform4.worldPos().y <= -60) direction4 = platformSpeed
    else if (platform4.worldPos().y >= 40) direction4 = -platformSpeed

    platform4.move(k.vec2(0, direction4))
  })

  const grassFinal = k.add([
    k.sprite('grass'),
    k.pos(620, 20),
    k.body({ isStatic: true }),
    k.area()
  ])

  const door = grassFinal.add([
    k.sprite('door'),
    k.pos(200, 0),
    k.area(),
    k.anchor('bot'),
    k.z(-1),
    'door'
  ])

  let atDoor = false
  let doorOpen = false

  robot.onCollide('door', () => {
    atDoor = true
    tooltipE.hidden = false
  })
  robot.onCollideEnd('door', () => {
    atDoor = false
    tooltipE.hidden = true
  })
  robot.onKeyPress('e', () => {
    if (atDoor && !doorOpen) {
      doorOpen = true
      door.play('open')
    } else if (atDoor && doorOpen) {
      k.go('five')
    }
  })
}
